// const pageData = {};
// const dealCheckedNum = (checkedKey: any) => {
//   const checked: number = checkedKey.length;
//   // desc 跨页多选
//   // Object.keys(checkedKey).forEach((key) => {
//   //   checked += checkedKey[key].length;
//   // });
//   return checked;
// };
import { __rest } from "tslib";
export const selectedTableRows = (selectedRowKeys, selectedRows, isMulPage, mark) => {
    // desc 跨页多选
    // const CheckedKey = approve[`checkedKey${mark}`];
    // const checkedVal = approve[`checkedVal${mark}`];
    // const pageIndex = approve[`pageIndex${mark}`];
    // CheckedKey[`index_${pageIndex}`] = selectedRowKeys;
    // checkedVal[`index_${pageIndex}`] = selectedRows;
    // const checkedNum = dealCheckedNum(selectedRowKeys);
    return selectedRowKeys;
};
export const dealTableScroll = (columns) => {
    const $table = document.querySelector('.scroll_table');
    if ($table) {
        const tableWidth = $table.clientWidth;
        let needWith = 0;
        columns.forEach(({ width }) => {
            needWith += width || 200;
        });
        if (needWith > tableWidth) {
            return {
                dealColumns: columns,
                scrollX: needWith,
            };
        }
        return {
            dealColumns: columns.map((item) => {
                const { width, fixed } = item, other = __rest(item, ["width", "fixed"]);
                return other;
            }),
            scrollX: undefined,
        };
    }
    return {
        dealColumns: columns,
        scrollX: undefined,
    };
};
